import React, { lazy, Suspense, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAgentPanel } from './AgentPanelContext';
import { defaultGuide, pageGuides } from './workspaceGuides';
import { PageHelpContext } from './PageHelpButton';

const ExampleWorkspaceTour = lazy(() => import('./ExampleWorkspaceTour'));

export default function WorkspaceFirstEntry({ activePage, children }) {
  const chat = useAgentPanel();
  const location = useLocation();
  const [tourOpen, setTourOpen] = useState(false);
  const pageGuide = pageGuides[activePage] || defaultGuide;
  const ask = () => {
    setTourOpen(false);

    chat.setDraftMessage(current => current?.trim() ? current : pageGuide.prompt);
    chat.setInteractionContext({
      source: chat.interactionContext?.source || 'page_help',
      label: chat.interactionContext?.label || `Help with ${pageGuide.name}`,
      context: { ...chat.interactionContext?.context, help_page_path: location.pathname + location.search },
    });
    chat.focusChatComposer();
  };
  return <PageHelpContext.Provider value={{ label: activePage === 'views' ? 'Help with this app' : 'Help with this page', open: () => setTourOpen(true) }}>
    {children}
    {tourOpen && <Suspense fallback={<div role="status" className="fixed bottom-16 right-24 z-30 rounded-lg bg-white p-3 text-sm shadow">Opening walkthrough…</div>}>
      <ExampleWorkspaceTour activePage={activePage} workspace={false} onClose={() => setTourOpen(false)} onAsk={ask} />
    </Suspense>}
  </PageHelpContext.Provider>;
}
